class VideoWithController extends HTMLElement {
  constructor() {
    super()
    this.controller = this.querySelector('.video-with-controller__controller')
    this.previewImage = this.querySelector('.video-with-controller__preview-image')
    this.video = this.querySelector('.video-div')

    this.controller.addEventListener('click', this.togglePlay.bind(this))
  }

  togglePlay() {
    if (this.video.paused) {
      this.dataset.play = 'play'
      this.video.play()
      // if (this.previewImage) this.previewImage.style.display = 'none'
    } else {
      this.dataset.play = 'pause'
      this.video.pause()
    } 
  }
}
customElements.define('video-with-controller', VideoWithController);

class LandingVideoSection extends HTMLElement {
  constructor() {
    super()

    this.videos = this.querySelectorAll('.landing-video__featured-video')
    this.thumbnails = this.querySelectorAll('.landing-video__thumbnail')

    this.thumbnails.forEach(thumbnail => {
      thumbnail.addEventListener('click', () => {
        const id = thumbnail.dataset.id

        this.stopVideos()
        this.dataset.active = id
      })
    })

    this.setupVideoTranslations()
  }

  stopVideos() {
    this.videos.forEach(el => {
      const videoWithController = el.querySelector('video-with-controller')
      const video = el.querySelector('video')

      videoWithController.dataset.play = 'stop'
      if (!video.paused) video.pause()
      video.currentTime = 0
    })
  }

  setupVideoTranslations() {
    setTimeout(() => {
      if (!window.Weglot) return
      
      this.lang = this.getWeglotLang()
      if (this.lang !== 'en') this.switchLang(this.lang)

      Weglot.on("languageChanged", (newLang, prevLang) => {
        this.lang = newLang
        this.switchLang(newLang)
      })
    }, 50)
  }

  getWeglotLang() {
    return window.Weglot.getCurrentLang()
  }

  switchLang(lang) {
    switch (lang) {
      case 'en':
        this.videos.forEach(video => {
          if (video.dataset.videoUrlEn) {
            video.querySelector('video').src = video.dataset.videoUrlEn
          }
        })
        break

      case 'tw':  // NOTE: tw and zh
        this.videos.forEach(video => {
          if (video.dataset.videoUrlZh) {
            video.querySelector('video').src = video.dataset.videoUrlZh
          }
        })
        break
      default:
        console.log(`Language ${lang} not supported`)
        break
    }
  }
}
customElements.define('landing-video-section', LandingVideoSection);

class LandingModelSlider extends HTMLElement {
  constructor() {
    super();

    this.slides = this.querySelectorAll(".landing-model-slider-item");
    this.modal = this.querySelector(".landing-model-slider-modal");
    this.wrapper = this.querySelector('.landing-model-slider-wrapper');

    this.modal.addEventListener("click", (e) => {
      if (e.target === this.modal) {
        this.modal.style.display = "none";
      }
    })

    const modelImg = this.modal.querySelector('.modal-img');
    const modelTitle = this.modal.querySelector('.title');
    const modelSubTitle = this.modal.querySelector('.sub-title');
    const modelIntro = this.modal.querySelector('.intro');
    const modelDescription = this.modal.querySelector('.description');
    const closeBtn = this.modal.querySelector('.modal__close');

    closeBtn.addEventListener('click', () => {
      this.modal.style.display = "none";
    })

    this.slides.forEach(slide => {
      slide.addEventListener('click', () => {
        modelImg.src = slide.dataset.popUpImage;

        modelTitle.innerText = slide.dataset.modelName;
        modelSubTitle.innerText = slide.dataset.modelSubtitle;
        modelIntro.innerText = slide.dataset.modelIntro;
        modelDescription.innerHTML = slide.dataset.modelDescription;

        if (window.location.pathname.includes('tw')) {
          modelTitle.innerText = slide.dataset.cnModelName;
          modelSubTitle.innerText = slide.dataset.cnModelSubtitle;
          modelIntro.innerText = slide.dataset.cnModelIntro;
          modelDescription.innerHTML = slide.dataset.cnModelDescription;
        }

        this.modal.style.display = "flex";
      })
    })

    let interval;
    const wrapperWidth = this.wrapper.clientWidth;

    this.wrapper.addEventListener('mouseenter', (e) => {
      clearInterval(interval)
      if (e.clientX < wrapperWidth/2) {
        interval = setInterval(() => this.wrapper.scrollLeft -= 1, 10)
      } else {
        interval = setInterval(() => this.wrapper.scrollLeft += 1, 10)
      }
    })

    this.wrapper.addEventListener('mouseover', (e) => {
      clearInterval(interval)

      let ratio = 2;

      if (e.clientX < wrapperWidth*0.3 || e.clientX > wrapperWidth*0.7) {
        ratio = 4;
      }

      if (e.clientX < wrapperWidth*0.15 || e.clientX > wrapperWidth*0.85) {
        ratio = 6;
      }

      if (e.clientX < wrapperWidth/2) {
        interval = setInterval(() => this.wrapper.scrollLeft -= 1 * ratio, 10)
      } else {
        interval = setInterval(() => this.wrapper.scrollLeft += 1 * ratio, 10)
      }
    })

    this.wrapper.addEventListener('mouseout', () => {
      clearInterval(interval)
    })

    this.wrapper.addEventListener('mouseleave', () => {
      clearInterval(interval)
    })
  }
}

customElements.define('landing-model-slider', LandingModelSlider)